import getMailboxMessageConfigurationOperation from 'owa-service/lib/operation/getMailboxMessageConfigurationOperation';
import updateUserOptions from 'mini-options-store/lib/utils/updateUserOptions';

/**
 * Async Action for loading the signature into the userOptions object
 */
export default async function loadSignatureInUserOptions(): Promise<void> {
    const messageConfigResponse = await getMailboxMessageConfigurationOperation();
    const options = messageConfigResponse && messageConfigResponse.Options;

    options &&
        (await updateUserOptions({
            UserOptions: {
                AutoAddSignatureOnMobile: options.AutoAddSignatureOnMobile,
                UseDesktopSignature: options.UseDefaultSignatureOnMobile,
                SignatureHtml: options.SignatureHtml,
                SignatureText: options.SignatureText,
                SignatureTextOnMobile: options.SignatureTextOnMobile,
            },
        }));
}
